import React, { useEffect, useRef } from 'react';
import { InfoWindow } from '@react-google-maps/api';
import { SHAPE_TYPE_PIN } from '../../util/constants';
import { getPolyInfoWindowPosition } from '../../util/polygon';
import usePolygonEventStore from '_viewport-maps/src/store/usePolygonEventStore';
function PopupShape({ shapeType, children, polygon, index, onClose, zIndex, options }) {
    const infoWindowRefs = useRef({});
    const { hoveredPolygonIndex, clickedPolygonIndex } = usePolygonEventStore(["hoveredPolygonIndex", "clickedPolygonIndex"]);
    useEffect(() => {
        if (infoWindowRefs.current[index]) {
            const infoWindowContainer = infoWindowRefs.current[index].containerElement.closest('.gm-style-iw-t');
            if (infoWindowContainer) {
                infoWindowContainer.style.display =
                    hoveredPolygonIndex > 0 || clickedPolygonIndex > 0 ? 'block' : 'none';
            }
        }
    }, [hoveredPolygonIndex, clickedPolygonIndex]);
    return (React.createElement(InfoWindow, { options: {
            // @ts-ignore
            pixelOffset: {
                height: shapeType === SHAPE_TYPE_PIN ? -35 : -15
            },
            ...options
        }, position: getPolyInfoWindowPosition(polygon), onCloseClick: () => {
            onClose();
        }, ref: (element) => (infoWindowRefs.current[index] = element), zIndex: zIndex },
        React.createElement("div", { className: "popup" },
            React.createElement("div", { className: "popup__content" }, children))));
}
export default React.memo(PopupShape);
